/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close[_ngcontent-%COMP%]{background:none;background-color:#fff;border-radius:30px;border:1px solid #edf6ff;color:#979797;font-size:small;font-weight:100;height:26px;line-height:24px;opacity:1;position:fixed;right:-5px;text-indent:unset;top:2px;width:26px}.close[_ngcontent-%COMP%]:hover{box-shadow:0 0 .15rem rgba(0,0,0,.5);color:#000}"];
export { styles as styles };
//# sourceMappingURL=circle-close-button.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/circle-close-button/circle-close-button.component.scss.shim.ngstyle.js
// module id = 1565
// module chunks = 27 28 29